import axios from 'axios';
  
const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})

async function get(api) {
    const response = await instance.get(api, {
        headers: {
            'Content-type': 'application/json'
        }
    });
    return response;
}

async function post(api, data) {
    const response = await instance.post(api,data, {
        headers: {
            'Content-type': 'application/json'
        }
    });
    return response;
}
export const Api = {
    get,
    post
} 
